import { gql } from '@apollo/client';
import { DealFragment } from '../fragments/DealFragment';
/**
 * @const CreateDealUpsellPaymentMutation
 * @since 1.0.0
 */
export const CreateDealUpsellPaymentMutation = gql `
  mutation CreateDealUpsellPaymentMutation(
    $input: CreateDealUpsellPaymentInput!
  ) {
    createDealUpsellPayment(input: $input) {
      ...DealFragment
    }
  }

  ${DealFragment}
`;
